module.exports = __webpack_public_path__ + "img/Jump Casting65.91ac5ce8.jpg";